import { Routes, Route } from "react-router-dom";
import Dashboard from '../pages/StudentDashboard/Dashboard.js';
import Applications from '../components/Applications';
import EditProfile from '../components/EditProfile/index.js';
import Layout from "../layout/index.js";
import ChangePassword from "../components/ChangePassword/index.js";

const routes = [
  { path: "", element: <Dashboard />, text: "Dashboard" },
  { path: "application", element: <Applications />, text: "Applications" },
];

const RecordKeeperRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout navItems={routes} />}>
        {routes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/change-password" element={<ChangePassword />} />
      </Route>
    </Routes>
  );
};

export default RecordKeeperRoutes;